import React, { useContext, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import "./payment.css";
import CheckoutForm from "./checkoutForm";
import { Icon, Layout, LoginLayout } from "@app/components";
import { SuccessContainer } from "@app/components/profileEditSuccess/success-components";
import { SuccessHeading, SuccessText } from "../signUp/sign-up.component";
import { TextCenter, ElementOrder, CommonLabel, PaymentInstructions } from "@app/components/commonStyles";
import { AuthContext } from "@app/providers";
import loginLayout from "@app/components/loginLayout";
import { PopUpText, PopUpTitle } from "@app/components/success-modal/success-modal-components";
import { stripeKey } from "../../providers/config"

const STRIPEKEY: any = stripeKey;
const stripePromise = loadStripe(STRIPEKEY);

const PaymentForm = () => {
    let paymentSource: any = localStorage.getItem("paymentSource");
    const [showPendingView, SetShowPendingView] = useState(paymentSource == "signIn");
    const [isSignIn, SetIsSignIn] = useState(paymentSource == "signIn");
    const { userInfo } = useContext(AuthContext);
    const [loginUserinfo, setLoginUserinfo] = useState<any>('')
    const [userType, setUserType] = useState()

    useEffect(() => {
        if (userInfo) {
            setLoginUserinfo(userInfo.userJson.userType === "parent" ? "Parent" : "Educator");
            setUserType(userInfo.userJson.userType)
        } else {
            let data: any = localStorage.getItem('paymentUser') || "";
            if (data) {
                data = JSON.parse(data);
                setUserType(data.userType)
                setLoginUserinfo(data.userType === "parent" ? "Parent" : "Educator");
            }
        }
    }, [userInfo])

    return (
        <>
            {showPendingView &&
                <>
                    <Layout>
                        <SuccessContainer className="p-0">
                            <Icon name="pending" />
                            <PopUpTitle>Age Verification Pending</PopUpTitle>
                            <PopUpText>
                                <button
                                    className="anchor-tag mt"
                                    type="button"
                                    onClick={() => SetShowPendingView(false)}
                                >
                                    Adult Verification
                                </button>
                                is pending. Please verify to continue.
                            </PopUpText>
                        </SuccessContainer>
                    </Layout>
                </>
            }
            {!showPendingView && isSignIn &&
                <>
                    <Layout >
                        <h3 className="primary-header text-center mb-3">
                            {loginUserinfo} Age Verification
                        </h3>
                        <PaymentInstructions>
                            <p className="m-0">In order to prove you,{userType === "educator" ? "as an Educator" : "as a Parent"}, are over 18, we have to verify a credit card in your name. Please enter a valid credit card below. We will only be placing a small Authorization to validate the credit card and you will not be charged.</p>
                        </PaymentInstructions>
                        <CommonLabel className="alt label-color fs-16 mb-1">Payment Details</CommonLabel>
                        <Elements stripe={stripePromise}>
                            <CheckoutForm SetShowPendingView={SetShowPendingView} />
                        </Elements>
                    </Layout>
                </>
            }

            {!showPendingView && !isSignIn &&
                <>
                    <LoginLayout path="" label="">
                        <h3 className="primary-header text-center mb-3">
                            {loginUserinfo} Age Verification
                        </h3>
                        <PaymentInstructions>
                            <p className="m-0">In order to prove you, {userType === "educator" ? "as an Educator" : "as a Parent"}, are over 18, we have to verify a credit card in your name. Please enter a valid credit card below. We will only be placing a small Authorization to validate the credit card and you will not be charged.</p>
                        </PaymentInstructions>
                        <CommonLabel className="alt label-color fs-16">Payment Details</CommonLabel>
                        <Elements stripe={stripePromise}>
                            <CheckoutForm SetShowPendingView={SetShowPendingView} />
                        </Elements>
                    </LoginLayout>
                </>
            }

        </>
    );
};

export default PaymentForm;
